<template>
  <div>
    <div class="ls_drawer_main_content">
      <Form ref="formData" :model="formData" :rules="rules">
        <!-- NAME -->
        <FormItem prop="name" :label="schema.name.label" >
          <Input v-model="formData.name" :placeholder="schema.name.label" />
        </FormItem>
        <!-- NAME | REGISTER NUMBER -->
        <Row :gutter="32"  v-if="action==='edit'">
          <Col :xs="24" :sm="24" :md="12">
            <!-- MANUFACTURE NUMBER -->
            <FormItem prop="name" :label="schema.manufacturer_number.label">
              <Input v-model="formData.manufacturer_number" :placeholder="schema.manufacturer_number.label" disabled />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12">
            <!-- REGISTER NUMBER -->
            <FormItem prop="reg_number" :label="schema.reg_number.label">
              <Input
                v-model="formData.reg_number"
                :placeholder="schema.reg_number.label"
              />
            </FormItem>
          </Col>
        </Row>
        <!-- ECONOMIC ACTIVITY -->
        <FormItem
          prop="economic_activity"
          :label="schema.economic_activity.label"
        >
          <Select v-model="formData.economic_activity">
            <Option
              v-for="item in schema.economic_activity.choices"
              :value="item.value"
              :key="item.value"
              >{{ item.display_name }}</Option
            >
          </Select>
        </FormItem>
        <!-- RECEIPT LANG -->
        <FormItem
          prop="receipt_lang" 
          label="Язык в фискальном чеке"
        >
          <!-- <Select v-model="formData.receipt_lang">
            <Option
              v-for="item in schema.receipt_lang.choices"
              :value="item.value"
              :key="item.value"
              >{{ item.display_name }}</Option
            >
          </Select> -->
          <Select v-model="formData.receipt_lang">
              <Option
                v-for="item in formSelectOptions.receipt_lang"
                :value="item.id"
                :key="item.id"
              >{{ item.name }}</Option
              >
            </Select>
        </FormItem>
        <Divider dashed="true"><h2>Расположение</h2></Divider>
        <!-- STORE | SECTION -->

        <!-- STORE -->
        <FormItem
          prop="store"
          :label="schema.store.label">
          <Select v-model="formData.store" filterable :disabled="action==='edit'">
            <Option
              v-for="item in formSelectOptions.stores"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- SECTION -->
        <FormItem prop="section" :label="schema.section.label">
          <Select v-model="formData.section" filterable>
            <Option
              v-for="item in formSelectOptions.sections"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- OPERATION PIN | SHIFT PIN -->
        <Row :gutter="32">
          <Col :xs="24" :sm="24" :md="12">
            <!-- OPERATION PIN -->
            <FormItem prop="operation_pin" :label="schema.operation_pin.label">
              <Input
                v-model="formData.operation_pin"
                :placeholder="schema.operation_pin.label"


              />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12">
            <!-- SHIFT PIN -->
            <FormItem prop="shift_pin" :label="schema.shift_pin.label">
              <Input
                v-model="formData.shift_pin"
                :placeholder="schema.shift_pin.label"


              />
            </FormItem>
          </Col>
        </Row>






        <div v-if="action==='edit'">
          <Divider>ОФД</Divider>

          <!-- OFD -->
          <FormItem prop="ofd_server" label="ОФД">
            <Select v-model="formData.ofd_server">
              <Option
                v-for="item in formSelectOptions.ofd_server"
                :value="item.id"
                :key="item.id"
              >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- TOKEN | OFD ID -->
          <Row :gutter="32" >
            <Col :xs="24" :sm="24" :md="12">
              <!-- TOKEN -->
              <FormItem prop="token" :label="schema.token.label">
                <Input
                v-model="formData.token"
                :placeholder="schema.token.label"
                />
              </FormItem>

            </Col>
            <Col :xs="24" :sm="24" :md="12">
              <!-- OFD ID -->
              <FormItem prop="ofd_id" :label="schema.ofd_id.label">
                <InputNumber
                  v-model="formData.ofd_id"
                  :placeholder="schema.ofd_id.label"
                  style="width: 100%"
                />
                <!--<Input-->
                  <!--v-model="formData.ofd_id"-->
                  <!--:placeholder="schema.ofd_id.label"-->
                <!--/>-->
              </FormItem>
            </Col>
          </Row>

          <Divider></Divider>
          <!-- OPERATION PIN | SHIFT PIN -->
<!--          <Row :gutter="32">-->
<!--            <Col :xs="24" :sm="24" :md="12">-->
<!--              &lt;!&ndash; OPERATION PIN &ndash;&gt;-->
<!--              <FormItem prop="operation_pin" :label="schema.operation_pin.label">-->
<!--                <Input-->
<!--                  v-model="formData.operation_pin"-->
<!--                  :placeholder="schema.operation_pin.label"-->
<!--                  type="password"-->
<!--                />-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--            <Col :xs="24" :sm="24" :md="12">-->
<!--              &lt;!&ndash; SHIFT PIN &ndash;&gt;-->
<!--              <FormItem prop="shift_pin" :label="schema.shift_pin.label">-->
<!--                <Input-->
<!--                  v-model="formData.shift_pin"-->
<!--                  :placeholder="schema.shift_pin.label"-->
<!--                  type="password"-->
<!--                />-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--          </Row>-->
        </div>
        <!--&lt;!&ndash; CASHIERS &ndash;&gt;-->
        <!--<FormItem prop="stores" :label="schema.cashiers.label">-->
          <!--<Select v-model="formData.cashiers" filterable multiple>-->
            <!--<Option-->
              <!--v-for="item in formSelectOptions.cashiers"-->
              <!--:value="item.id"-->
              <!--:key="item.id"-->
              <!--&gt;{{ item.name }}</Option-->
            <!--&gt;-->
          <!--</Select>-->
        <!--</FormItem>-->
      </Form>
    </div>
    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" type="error" @click="cancelAction()"><Icon type="md-close" /></Button>
      <Button
        type="success"
        @click="saveAction()"
        :disabled="disabledSaveButton"
        ><Icon type="md-checkmark" /></Button
      >
    </div>
  </div>
</template>

<script>
import { base_url } from "../../http.js";
import { BaseFormData } from "../../base/base_form_v2.js";
let _app = BaseFormData();

_app.data = function() {
  return {
    loading: true,
    // schema: {},
    baseRules: {},
    excludeFieldsRules: ["economic_activity"],
    // extraRules: {},
    validForm: false,
    isChanged: false,

    formData: {
      name: "",
      reg_number: "",
      economic_activity: "",
      store: "",
      section: "",
      token: "",
      ofd_id: null,
      operation_pin: null,
      shift_pin: null,
      manufacturer_number: '',
      ofd_server: '',
      receipt_lang: '',
      // cashiers: []
    },

    formDefaultInitData: {
      name: "",
      reg_number: "",
      economic_activity: "",
      store: "",
      section: "",
      token: "",
      ofd_id: null,
      operation_pin: null,
      shift_pin: null,
      manufacturer_number: '',
      ofd_server: '',
      receipt_lang: ''
      // cashiers: []
    },

    formSelectOptions: {
      // cashiers: [],
      stores: [],
      sections: [],
      ofd_server: [
        {id: '10', name: 'АО "Казахтелеком"'},
        {id: '20', name: 'АО "Транстелеком"'},
        {id: '30', name: 'АО "Jusan Mobile"'},
        {id: '40', name: 'ТОО IT Analytics'}
      ],
      receipt_lang: [
        {id: 'ru', name: 'Русский'},
        {id: 'kk', name: 'Казахский'},
        {id: 'kk_ru', name: 'Комбинированный (kz + ru)'}
      ]
    },

    extraRules: {
      token:{
        required: true,
        message: "Введите корректное значение поля",
        trigger: "change"
      },
      ofd_id:{
        required: true,
        type: "number",
        message: "Введите корректное значение поля",
        trigger: "change"
      },
      operation_pin:{
        required: true,
        // type: "number",
        message: "PIN должен состоять из 4 цифр",
        trigger: "change",
        pattern: /^[0-9]{4}$/,
      },
      shift_pin:{
        required: true,
        // type: "number",
        message: "PIN должен состоять из 4 цифр",
        trigger: "change",
        pattern: /^[0-9]{4}$/,
      },
        section: {
            required: true,
            message: "Выберите корректное значение поля",
            trigger: "change"
        },
      ofd_server: {
        required: true,
        message: "Выберите корректное значение поля",
        trigger: "change"
      },
      receipt_lang: {
        required: true,
        message: "Выберите корректное значение поля",
        trigger: "change"
      }
    }
  };
};

// Справочники
// _app.methods.getCashiers = function() {
//   const url = base_url + "/options/cashiers/";
//   this.$http
//     .get(url)
//     .then(result => {
//       this.formSelectOptions.cashiers = result.data.results;
//     })
//     .catch(error => {
//       this.$Message.error("Ошибка получения списка кассиров");
//     });
// };
_app.methods.getStores = function() {
  const url = base_url + "/options/stores/";
  this.$http
    .get(url)
    .then(result => {
      this.formSelectOptions.stores = result.data.results;
    })
};

_app.methods.getSections = function(store_id) {
  const url = base_url + "/stores/" + store_id + "/get_sections/";
  this.$http
    .get(url)
    .then(result => {
      this.formSelectOptions.sections = result.data.results;
    })
};

_app.mounted = function() {
  // this.getCashiers();
  this.getStores();

  this.baseRules.economic_activity = [
    {
      required: true,
      type: "number",
      // message: this.schema[field].help_text,
      message: "Выберите корректное значение поля",
      trigger: "change"
    }
  ];

  // if (this.formData.store) {
  //   this.getSections(this.formData.store);
  // }
};

_app.watch["formData.store"] = function(newValue, oldValue) {
  this.validateForm();
  this.isChanged = true;

  if (this.action === "create") this.formData.section = "";
  this.getSections(newValue);
  // console.log('dddddddddddd ' + newValue);
};

_app.watch["formData.token"] = function(newValue, oldValue) {
  this.validateForm();
  this.isChanged = true;
};
_app.watch["formData.ofd_id"] = function(newValue, oldValue) {
  this.validateForm();
  this.isChanged = true;
};
_app.watch["formData.operation_pin"] = function(newValue, oldValue) {
  this.validateForm();
  this.isChanged = true;
};
_app.watch["formData.shift_pin"] = function(newValue, oldValue) {
  this.validateForm();
  this.isChanged = true;
};
_app.watch["formData.ofd_server"] = function(newValue, oldValue) {
  this.validateForm();
  this.isChanged = true;
};


export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/cash/cashForm.vue